export default {
  getTranslateValues(element) {
    if (!element) {
      return {
        x: 0,
        y: 0,
        z: 0,
      }
    }
    const style = window.getComputedStyle(element)
    const matrix = style.transform || style.mozTransform

    // No transform property. Simply return 0 values.
    if (matrix === 'none' || typeof matrix === 'undefined') {
      return {
        x: 0,
        y: 0,
        z: 0,
      }
    }

    // Can either be 2d or 3d transform
    const matrixType = matrix.includes('3d') ? '3d' : '2d'
    const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')

    // 2d matrices have 6 values
    // Last 2 values are X and Y.
    // 2d matrices does not have Z value.
    if (matrixType === '2d') {
      return {
        x: matrixValues[4],
        y: matrixValues[5],
        z: 0,
      }
    }

    // 3d matrices have 16 values
    // The 13th, 14th, and 15th values are X, Y, and Z
    if (matrixType === '3d') {
      return {
        x: matrixValues[12],
        y: matrixValues[13],
        z: matrixValues[14],
      }
    }

    return {
      x: 0,
      y: 0,
      z: 0,
    }
  },

  getRotationAngle(element) {
    const obj = window.getComputedStyle(element, null)
    const matrix = obj.getPropertyValue('-webkit-transform') ||
    obj.getPropertyValue('-moz-transform') ||
    obj.getPropertyValue('-ms-transform') ||
    obj.getPropertyValue('-o-transform') ||
    obj.getPropertyValue('transform')

    let angle = 0

    if (matrix !== 'none') {
      const values = matrix.split('(')[1].split(')')[0].split(',')
      const a = values[0]
      const b = values[1]
      angle = Math.round(Math.atan2(b, a) * (180 / Math.PI))
    }

    if (angle < 0) {
      angle += 360
    }

    return angle
  },
  isBlockNotInCanvas(blockId) {
    if (!blockId) return true
    const slideContainer = document.getElementById('slide-container')
    const canvasRect = slideContainer.getBoundingClientRect()
    const block = document.getElementById(blockId)
    const blockRect = block.getBoundingClientRect()

    const padding = 5
    if (canvasRect.x + canvasRect.width - padding < blockRect.x ||
        blockRect.x + blockRect.width - padding < canvasRect.x ||
        blockRect.y + blockRect.height - padding < canvasRect.y ||
        canvasRect.y + canvasRect.height - padding < blockRect.y
    ) {
      return true
    }
    return false
  },
}
